import { restClient } from '@/Core'

import { ACTIVITY_REST_URL } from '../Contracts/Activity.types'

import type { ActivityHistoryItem } from '../Helpers/activityHistoryEntries'

/** Подій за раз (`SPEC-011` §6): без параметра бек віддав би 100. */
export const ACTIVITY_HISTORY_LIMIT = 30

type HistoryResponse =
    | { items?: ActivityHistoryItem[]; 'hydra:member'?: ActivityHistoryItem[]; meta?: { total?: number } }
    | ActivityHistoryItem[]
    | null

/**
 * Стрічка «Історія змін» справи — `GET /services/activities/{uuid}/history`:
 * новіші зверху (так віддає бек), по 30.
 *
 * `forceRefresh`: ядровий клієнт дедуплікує GET на 30 с, і без нього
 * вкладка після «Зберегти» чи «Завершити справу» показала б стару стрічку.
 */
export const LoadActivityHistoryTask = async (
    uuid: string
): Promise<{ items: ActivityHistoryItem[]; total: number }> => {
    const raw = await restClient.get(
        `${ACTIVITY_REST_URL}/${encodeURIComponent(uuid)}/history?limit=${ACTIVITY_HISTORY_LIMIT}`,
        undefined,
        { forceRefresh: true }
    )
    const data = raw as unknown as HistoryResponse
    const list = Array.isArray(data) ? data : (data?.items ?? data?.['hydra:member'] ?? [])
    const items = Array.isArray(list) ? list : []
    const total = !Array.isArray(data) && typeof data?.meta?.total === 'number' ? data.meta.total : items.length

    return { items, total }
}
